import { render, staticRenderFns } from "./TrainingDashboard.vue?vue&type=template&id=1c4865c9&scoped=true&"
import script from "./TrainingDashboard.vue?vue&type=script&lang=js&"
export * from "./TrainingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDashboard.vue?vue&type=style&index=0&id=1c4865c9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4865c9",
  null
  
)

export default component.exports